export default __webpack_public_path__ + "static/media/category_1.0d6e2564.png";